import React, {useState} from 'react'

const DueDate = () => {

   const [startDate2, setStartDate2] = useState("");
   const [numWorkingDays, setNumWorkingDays] = useState("");
   const [excludeWeekends, setExcludeWeekends] = useState(false);
   const [outputDate, setOutputDate] = useState("");

   const handleStartDateChange2 = (event) => {
      setStartDate2(event.target.value);
   };

   const handleNumWorkingDaysChange = (event) => {
      setNumWorkingDays(event.target.value);
   };

   const handleExcludeWeekendsChange = (event) => {
      setExcludeWeekends(event.target.checked);
   };

   const calculateDate = (event) => {
      event.preventDefault();
      let currentDate = new Date(startDate2);
      // loop through each working day and add to the date
      for (let i = 0; i < numWorkingDays; i++) {
         // if excluding weekends, skip Saturday and Sunday
         if (excludeWeekends) {
            let dayOfWeek = currentDate.getDay();
            if (dayOfWeek === 6) { // Saturday
               currentDate.setDate(currentDate.getDate() + 2); // add 2 days for Sunday and Monday
            } else if (dayOfWeek === 0) { // Sunday
               currentDate.setDate(currentDate.getDate() + 1); // add 1 day for Monday
            }
         }
         // add 1 day to the date
         currentDate.setDate(currentDate.getDate() + 1);
      }
      // set the output date
      setOutputDate(currentDate.toDateString());
   };

   return (
      <div className="w-[100%] lg:w-[50%] mx-auto mt-[50px]">
         <h1 className="font-bold text-[30px]">Calculate due date</h1>
         <h2 className="text-[20px] text-purple-800">Figure out the day by which your project can be completed</h2>
         <div className="w-[100%] md:w-[700px] bg-gray-200 mt-[30px] p-[30px] rounded-lg drop-shadow-xl">
            <div className="flex gap-[15px] flex-col md:flex-row justify-between items-center">
               <div className="">
                  <label className="text-[20px] font-medium" htmlFor="start">Start Date</label>
                  <br /><br />
                  <input value={startDate2} onChange={handleStartDateChange2} className="outline-none w-[250px] h-[50px] rounded-lg px-[20px]" type="date" name="start" id="" />
               </div>
               <div className="w-[20px] hidden md:block h-[2px] bg-gray-800 translate-y-[30px]"></div>
               <div className="">
                  <label className="text-[20px] font-medium" htmlFor="end">Working Days</label>
                  <br /><br />
                  <input value={numWorkingDays} onChange={handleNumWorkingDaysChange} className="outline-none w-[250px] h-[50px] rounded-lg px-[20px]" type="text" name="end" id="" />
               </div>

            </div>
            <div className="border-b-[1px] border-b-gray-400 py-[30px] font-light">
               <input checked={excludeWeekends} onChange={handleExcludeWeekendsChange} className="mr-[8px]" type="checkbox" id="vehicle1" name="vehicle1" value="count"></input> Exclude the weekends
            </div>
            <button onClick={calculateDate} className="bg-gradient-to-r from-violet-500 to-indigo-500 hover:opacity-75 text-[20px] w-[210px] mx-auto mt-[30px] rounded-full text-white h-[55px] flex justify-center items-center gap-[10px]">
               Calculate
            </button>
            <div className="py-[30px] flex flex-col gap-[10px] sm:flex-row justify-between">
               <div className="flex sm:flex-col gap-[10px]">
                  <div className="text-[20px] font-medium">End Date</div>
                  <div className="text-[20px] font-medium">{outputDate ? outputDate : "--/--/--"}</div>
               </div>
               <div className="sm:text-end font-light text-gray-600">
                  Start and end dates are included
                  <br />
                  <a className="text-blue-500 underline">National holidays </a> are counted as working days
               </div>
            </div>
         </div>
      </div>
   )
}

export default DueDate
